import { t as themeDefault, C as COMMON_COLOR_BRAND_PRIMARY, a as COMMON_COLOR_PARK_UOR_CITYWALK, b as COMMON_COLOR_PARK_UOR_IOA_JURASSIC, c as COMMON_COLOR_PARK_UOR_IOA_MARVEL_SUPER_HERO_ISLAND, d as COMMON_COLOR_PARK_UOR_IOA_PORT_OF_ENTRY, e as COMMON_COLOR_PARK_UOR_IOA_SKULL_ISLAND_REIGN_OF_KONG, f as COMMON_COLOR_PARK_UOR_IOA_THE_LOST_CONTINENT, g as COMMON_COLOR_PARK_UOR_IOA_TOON_LAGOON, h as COMMON_COLOR_PARK_UOR_IOA_THE_WIZARDING_WORLD_OF_HARRY_POTTER_HOGSMEADE, i as COMMON_COLOR_PARK_UOR_USF_HOLLYWOOD, j as COMMON_COLOR_PARK_UOR_USF_NEW_YORK, k as COMMON_COLOR_PARK_UOR_USF_PRODUCTION_CENTRAL, l as COMMON_COLOR_PARK_UOR_USF_SAN_FRANCISCO, m as COMMON_COLOR_PARK_UOR_USF_THE_WIZARDING_WORLD_OF_HARRY_POTTER_DIAGON_ALLEY, n as COMMON_COLOR_PARK_UOR_USF_WORLD_EXPO, o as COMMON_COLOR_PARK_UOR_VB_RAINFOREST_VILLAGE, p as COMMON_COLOR_PARK_UOR_VB_RIVER_VILLAGE, q as COMMON_COLOR_PARK_UOR_UEU_P900, r as COMMON_COLOR_PARK_UOR_UEU_P902, s as COMMON_COLOR_PARK_UOR_UEU_P903, u as COMMON_COLOR_PARK_USH_SUPER_NINTENDO_WORLD, v as COMMON_COLOR_BRAND_SECONDARY, w as COMMON_COLOR_PARK_USH_CITYWALK, x as COMMON_COLOR_PARK_USH_JURASSIC_WORLD, y as COMMON_COLOR_PARK_USH_TRANSFORMERS_METROBASE, z as COMMON_COLOR_PARK_USH_HOLLYWOOD, A as COMMON_COLOR_PARK_USH_PRODUCTION_PLAZA, B as COMMON_COLOR_PARK_USH_STUDIO_TOUR_PLAZA, D as COMMON_COLOR_PARK_USH_WATERWORLD, E as COMMON_COLOR_PARK_USH_THE_WIZARDING_WORLD_OF_HARRY_POTTER, F as COMMON_COLOR_PARK_USJ_AMITY_VILLAGE, G as COMMON_COLOR_PARK_USJ_HOLLYWOOD, H as COMMON_COLOR_PARK_USJ_JURASSIC, I as COMMON_COLOR_PARK_USJ_NEW_YORK, J as COMMON_COLOR_PARK_USJ_SAN_FRANCISCO, K as COMMON_COLOR_PARK_USJ_SUPER_NINTENDO_WORLD, L as COMMON_COLOR_PARK_USJ_THE_WIZARDING_WORLD_OF_HARRY_POTTER, M as COMMON_COLOR_PARK_USJ_WATERWORLD } from './_semantic_default-b9a02e61.js';

/**
 *
 * @param dataObj
 * @param bgColorVal
 * @param atomPrefix *
 *
 * Fetches the color value needed.
 * dataObj is the data object from the requesting component (usually this._data).
 *
 * bgColorVal example: 'uor.usf.super-nintendo-world-test'.
 *
 * atomPrefix example: 'COMMON_COLOR_PARK_' which can be found in semantic_default.ts file.
 */
const getBackgroundColor = (bgColorVal, atomPrefix) => {
  if (!bgColorVal || !atomPrefix) return '';
  if (msPlacesLandMapping.hasOwnProperty(bgColorVal)) {
    return msPlacesLandMapping[bgColorVal];
  }
  bgColorVal = bgColorVal.includes('-') ? bgColorVal.replace(/-/g, '.') : bgColorVal;
  bgColorVal = bgColorVal?.split('.')?.join('_')?.toUpperCase();
  const background = atomPrefix + bgColorVal;
  return (themeDefault[`${background}`] || themeDefault[`${background}`]) ?? COMMON_COLOR_BRAND_PRIMARY;
};
// This mapping table is temporary until we switch to pulling in theme.
const msPlacesLandMapping = {
  // UOR LAND ID COLOR MAPPING
  'uor.cw.citywalk': COMMON_COLOR_PARK_UOR_CITYWALK,
  'uor.ioa.jurassic_park': COMMON_COLOR_PARK_UOR_IOA_JURASSIC,
  'uor.ioa.marvel_super_hero_island': COMMON_COLOR_PARK_UOR_IOA_MARVEL_SUPER_HERO_ISLAND,
  'uor.ioa.port_of_entry': COMMON_COLOR_PARK_UOR_IOA_PORT_OF_ENTRY,
  'uor.ioa.seuss_landing': '#887325',
  'uor.ioa.skull_island_reign_of_kong': COMMON_COLOR_PARK_UOR_IOA_SKULL_ISLAND_REIGN_OF_KONG,
  'uor.ioa.the_lost_continent': COMMON_COLOR_PARK_UOR_IOA_THE_LOST_CONTINENT,
  'uor.ioa.toon_lagoon': COMMON_COLOR_PARK_UOR_IOA_TOON_LAGOON,
  'uor.ioa.wizarding_world_of_harry_potter_hogsmeade': COMMON_COLOR_PARK_UOR_IOA_THE_WIZARDING_WORLD_OF_HARRY_POTTER_HOGSMEADE,
  'uor.usf.dreamworks_land': '#0880A1',
  'uor.usf.hollywood': COMMON_COLOR_PARK_UOR_USF_HOLLYWOOD,
  'uor.usf.illuminations_minion_land': '#906400',
  'uor.usf.newyork': COMMON_COLOR_PARK_UOR_USF_NEW_YORK,
  'uor.usf.production_central': COMMON_COLOR_PARK_UOR_USF_PRODUCTION_CENTRAL,
  'uor.usf.sanfrancisco': COMMON_COLOR_PARK_UOR_USF_SAN_FRANCISCO,
  'uor.usf.springfield_simpsons': '#B36200',
  'uor.usf.the_wizarding_world_of_harry_potter_diagon_alley': COMMON_COLOR_PARK_UOR_USF_THE_WIZARDING_WORLD_OF_HARRY_POTTER_DIAGON_ALLEY,
  'uor.usf.woody_woodpeckers_kidzone': '#0880A1',
  'uor.usf.world_expo': COMMON_COLOR_PARK_UOR_USF_WORLD_EXPO,
  'uor.vb.rain_forest_village': COMMON_COLOR_PARK_UOR_VB_RAINFOREST_VILLAGE,
  'uor.vb.river_village': COMMON_COLOR_PARK_UOR_VB_RIVER_VILLAGE,
  'uor.vb.the_volcano': '#0880A1',
  'uor.vb.wave_village': '#E61B00',
  // EPIC UNIVERSE COLORS
  'uor.eu.celestialpark': COMMON_COLOR_PARK_UOR_UEU_P900,
  'uor.eu.darkuniverse': COMMON_COLOR_PARK_UOR_UEU_P902,
  'uor.eu.httyd': COMMON_COLOR_PARK_UOR_UEU_P903,
  'uor.eu.snw': COMMON_COLOR_PARK_USH_SUPER_NINTENDO_WORLD,
  'uor.eu.hpmom': COMMON_COLOR_PARK_UOR_USF_THE_WIZARDING_WORLD_OF_HARRY_POTTER_DIAGON_ALLEY,
  // UOR HOTELS
  'uor.hard_rock_hotel_orlando': COMMON_COLOR_BRAND_SECONDARY,
  'uor.loews_portofino_bay_hotel': COMMON_COLOR_BRAND_SECONDARY,
  'uor.loews_royal_pacific_resort': COMMON_COLOR_BRAND_SECONDARY,
  'uor.loews_sapphire_falls_resort': COMMON_COLOR_BRAND_SECONDARY,
  'uor.universals_aventura_hotel': COMMON_COLOR_BRAND_SECONDARY,
  'uor.universals_cabana_bay_beach_resort': COMMON_COLOR_BRAND_SECONDARY,
  'uor.universal_cabana_bay_beach_resort': COMMON_COLOR_BRAND_SECONDARY,
  'uor.universals_dockside_inn_and_suites': COMMON_COLOR_BRAND_SECONDARY,
  'uor.universals_endless_summer_resort_surfside_inn_and_suites': COMMON_COLOR_BRAND_SECONDARY,
  'uor.universals_surfside_inn_and_suites': COMMON_COLOR_BRAND_SECONDARY,
  // USH LAND ID COLOR MAPPING
  'ush.cw.city_walk': COMMON_COLOR_PARK_USH_CITYWALK,
  'ush.lower_lot.jurassic_world': COMMON_COLOR_PARK_USH_JURASSIC_WORLD,
  'ush.lower_lot.super_nintendo_world': COMMON_COLOR_PARK_USH_SUPER_NINTENDO_WORLD,
  'ush.lower_lot.transformers_metrobase': COMMON_COLOR_PARK_USH_TRANSFORMERS_METROBASE,
  'ush.upper_lot.hollywood': COMMON_COLOR_PARK_USH_HOLLYWOOD,
  'ush.upper_lot.minion_land': '#906400',
  'ush.upper_lot.production_plaza': COMMON_COLOR_PARK_USH_PRODUCTION_PLAZA,
  'ush.upper_lot.springfield': '#B36200',
  'ush.upper_lot.studio_tour_plaza': COMMON_COLOR_PARK_USH_STUDIO_TOUR_PLAZA,
  'ush.upper_lot.water_world': COMMON_COLOR_PARK_USH_WATERWORLD,
  'ush.upper_lot.waterworld': COMMON_COLOR_PARK_USH_WATERWORLD,
  'ush.upper_lot.wwohp': COMMON_COLOR_PARK_USH_THE_WIZARDING_WORLD_OF_HARRY_POTTER,
  // USJ LAND ID COLOR MAPPING
  'usj.usj.amity_village': COMMON_COLOR_PARK_USJ_AMITY_VILLAGE,
  'usj.usj.hollywood': COMMON_COLOR_PARK_USJ_HOLLYWOOD,
  'usj.usj.jurassic_park': COMMON_COLOR_PARK_USJ_JURASSIC,
  'usj.usj.minion_park': '#906400',
  'usj.usj.newyork': COMMON_COLOR_PARK_USJ_NEW_YORK,
  'usj.usj.sanfrancisco': COMMON_COLOR_PARK_USJ_SAN_FRANCISCO,
  'usj.usj.snw': COMMON_COLOR_PARK_USJ_SUPER_NINTENDO_WORLD,
  'usj.usj.the_wizarding_world_of_harry_potter': COMMON_COLOR_PARK_USJ_THE_WIZARDING_WORLD_OF_HARRY_POTTER,
  'usj.usj.universal_wonderland': '#0880A1',
  'usj.usj.water_world': COMMON_COLOR_PARK_USJ_WATERWORLD,
  // THEME TO COLOR MAPPING
  'theme-amity-village': COMMON_COLOR_PARK_USJ_AMITY_VILLAGE,
  'theme-celestial-park': COMMON_COLOR_PARK_UOR_UEU_P900,
  'theme-citywalk': COMMON_COLOR_PARK_UOR_CITYWALK,
  'theme-dark-universe': COMMON_COLOR_PARK_UOR_UEU_P902,
  'theme-default': COMMON_COLOR_BRAND_PRIMARY,
  'theme-dreamworks-land': '#0880A1',
  'theme-hollywood': COMMON_COLOR_PARK_UOR_USF_HOLLYWOOD,
  'theme-hotels': COMMON_COLOR_BRAND_SECONDARY,
  'theme-httyd-isle-of-berk': COMMON_COLOR_PARK_UOR_UEU_P903,
  'theme-jurassic': COMMON_COLOR_PARK_UOR_IOA_JURASSIC,
  'theme-kong': COMMON_COLOR_PARK_UOR_IOA_SKULL_ISLAND_REIGN_OF_KONG,
  'theme-marvel': COMMON_COLOR_PARK_UOR_IOA_MARVEL_SUPER_HERO_ISLAND,
  'theme-minionland': '#906400',
  'theme-new-york': COMMON_COLOR_PARK_UOR_USF_NEW_YORK,
  'theme-port-of-entry': COMMON_COLOR_PARK_UOR_IOA_PORT_OF_ENTRY,
  'theme-production-central': COMMON_COLOR_PARK_UOR_USF_PRODUCTION_CENTRAL,
  'theme-rainforest-village': COMMON_COLOR_PARK_UOR_VB_RAINFOREST_VILLAGE,
  'theme-river-village': COMMON_COLOR_PARK_UOR_VB_RIVER_VILLAGE,
  'theme-san-francisco': COMMON_COLOR_PARK_UOR_USF_SAN_FRANCISCO,
  'theme-seuss': '#887325',
  'theme-springfield': '#B36200',
  'theme-studio-tour-plaza': COMMON_COLOR_PARK_USH_STUDIO_TOUR_PLAZA,
  'theme-super-nintendo': COMMON_COLOR_PARK_USH_SUPER_NINTENDO_WORLD,
  'theme-the-volcano': '#0880A1',
  'theme-toon-lagoon': COMMON_COLOR_PARK_UOR_IOA_TOON_LAGOON,
  'theme-transformers': COMMON_COLOR_PARK_USH_TRANSFORMERS_METROBASE,
  'theme-waterworld': COMMON_COLOR_PARK_USH_WATERWORLD,
  'theme-wave-village': '#E61B00',
  'theme-world-expo': COMMON_COLOR_PARK_UOR_USF_WORLD_EXPO,
  'theme-wwohp': COMMON_COLOR_PARK_UOR_IOA_THE_WIZARDING_WORLD_OF_HARRY_POTTER_HOGSMEADE
};
export { getBackgroundColor as g };

